angular.module('cvsApp').service('getAddressSuggestionService',['networkService', 'xdrService', 'configManager', 'getAddressSuggestionModel','cvsAppData', function (NS, XS,CM, GASM, CAD) {
   	
	function getAddressSuggestion (){
		this.getAddressSuggestionsData = function(query, callBackSuccess,guestTokenID){
			//get url
			var tokenId, tokenType;
			/*var tokenId=CAD.getTokenId();
			 var tokenType=CAD.getTokenType();*/
			var token = cvsUtility.queryMap.token,
                timeStamp = cvsUtility.queryMap.timeStamp ? cvsUtility.queryMap.timeStamp : (cvsUtility.queryMap.timestamp ? cvsUtility.queryMap.timestamp : '');
			try{
				tokenId = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
			}
			catch(ex){
				tokenId = guestTokenID || cvsUtility.queryMap.tokenId;
				tokenType = (guestTokenID) ? 'Guest' : 'Login';
			}
			var url = CM.getAPIUrlWithHMAC('GET_ADD_SUGGESTIONS', tokenId, tokenType, token, timeStamp);
			if(url === "URL_ERROR"){

			}else{
				url += '&searchText='+query;
				var plainUrl = CM.getPlainApiUrl(url);
				var request = {
							url:plainUrl,
							header:{"Content-Type":"application/json", "accept": "application/xml"},
							data:getRequestBody(url),
							onSuccess:callBackSuccess
						}
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(plainUrl, getRequestBody(url), xdrSuccess);

					function xdrSuccess (data) {
						GASM.setResponse(data);
						callBackSuccess(GASM.getResponse());
					}
				}
				else {
					var promise = NS.post(request);	
					promise.then(function(data, c, d){
						
						GASM.setResponse(data.data);
						callBackSuccess(GASM.getResponse());

						
					}, function(reason){
						callBackSuccess(NS.httpError(reason));
					});
				}
			}
							
		}
		var getRequestBody = function(entities){
			var requestJson = { serviceParams: CM.getModifiedParams(entities) };
			return requestJson;
		};	

		// var getRequestBody = function(guestTokenID){
		// 		var date = new Date();			
		// 		var currentYear = date.getFullYear();
		// 		var currentMonth =convertToTwoDigit(date.getMonth() + 1);
		// 		var currentDay = convertToTwoDigit(date.getDate());
				
		// 		var hour = convertToTwoDigit(date.getHours());
		// 		var minute = convertToTwoDigit(date.getMinutes());
		// 		var second = convertToTwoDigit(date.getSeconds());

		// 		var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour 
		// 			+ ':' + minute + ':' + second;
		// 	var tokenId, tokenType;
		// 	/*var tokenId=CAD.getTokenId();
		// 	 var tokenType=CAD.getTokenType();*/
		// 	try{
		// 		tokenId = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
		// 		tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
		// 	}
		// 	catch(ex){
		// 		tokenId = guestTokenID || cvsUtility.queryMap.tokenId;
		// 		tokenType = (guestTokenID) ? 'Guest' : 'Login';
		// 	}
		// 		var requestJson = {request:{
		// 						tokenID:tokenId,
		// 						tokenType:tokenType,
		// 						apiKey:cvsUtility.queryMap.apikey,
		// 						timestamp:timeStamp}}               
				
		// 		return cvsUtility.JSONToXml(requestJson);

		// 		function convertToTwoDigit (number) {
		// 			return (number < 10) ? '0' + number : number;
		// 		}
		// 	}
	
	}
	
	return new getAddressSuggestion();	
}]);
